const mutations = {
  setHeaderFooterOptions(state, payload) {
    state.tncHeaderFooterOptions = payload;
  },
  setSchemes(state, payload) {
    state.schemes = payload;
  },
  setGeneralFormData(state, payload) {
    state.generalMasterData = payload;
  },
  setCreateschemeForm(state, payload) {
    state.createSchemeForm.planNo = payload.planNo;
    if (payload.hasOwnProperty("general")) {
      state.createSchemeForm.general = payload.general;
    }
    if (payload.hasOwnProperty("program")) {
      state.createSchemeForm.program = payload.program;
    }
    if (payload.hasOwnProperty("programSelectedRow")) {
      state.createSchemeForm.programSelectedRow = payload.programSelectedRow;
    }
    if (payload.hasOwnProperty("planRow")) {
      state.createSchemeForm.planRow = payload.planRow;
    }
  },
  setGroups(state, payload) {
    state.groups = payload;
  },
  setPartnerGroups(state, payload) {
    state.partnerGroups = payload;
  },
  setProductGroups(state, payload) {
    state.productGroups = payload;
  },
  setCreatePartnerGroupData(state, payload) {
    state.createPartnerGroupData = payload;
  },
  setSingleGroupData(state, payload) {
    state.singleGroupData = payload;
  },
  setGroupTypeDetails(state, payload) {
    state.groupTypeDetails = payload;
  },
  setSchemeLoader(state, payload) {
    state.loader[payload.type] = payload.val;
  },
  setProductGroupMasterData(state, payload) {
    state.createProductGroupData = payload;
  },
  setProductlevelData(state, payload) {
    state.productLevelData = payload;
  },
  setschemeProgramMasterData(state, payload) {
    state.schemeProgramMasterData = payload;
  },
  setEligibilityMasterData(state, payload) {
    state.eligibilityMasterData = payload;
  },
  setSelectedPartnerDetails(state, payload) {
    state.selectedPatnerDetail = payload;
  },
  setTargetMasterData(state, payload) {
    state.targetMasterData = payload;
  },
  setbugetSubCatItem(state, payload) {
    state.bugetSubCatItem = payload;
  },
  setvalidationLinkData(state, payload) {
    state.vallidationLinkData = payload;
  },
  setPayoutMasterData(state, payload) {
    state.payoutMasterData = payload;
  },
  setTargetLinkData(state, payload) {
    state.targetLinkData = payload;
  },
  setGeneralSectionData(state, payload) {
    state.generalSectionData = payload;
  },
  setMasterPartnerGeo(state, payload) {
    state.partnerGeo.geoElement = payload.geoElements;
    state.partnerGeo.GeoValue = payload.geoValues;
  },
  setEligibilityRangeStartDate(state, payload) {
    state.eligibilityRangeStartDate = payload;
  },
  setSlabMinValue(state, payload) {
    state.slabMinValue = payload;
  },
  setDemoDeductionStartDateValue(state, payload) {
    state.demoDeductionStartDateValue = payload;
  },
  setBizSlabMinValue(state, payload) {
    state.bizSlabMinValue = payload;
  },
  setSchemeProgramData(state, payload) {
    state.schemeProgramData = payload;
  },
  setViewTarget(state, payload) {
    state.viewTarget = payload;
  },
  setTargetException(state, payload) {
    state.targetException = payload;
  },
  setschemeExceptionSelectedPlans(state, payload) {
    state.schemeExceptionSelectedPlans.selectedPlanNos =
      payload.selectedPlanNos;
    state.schemeExceptionSelectedPlans.canCheckschemePlanList =
      payload.canCheckschemePlanList;
  },
  setSelectedPlanListRows(state, payload) {
    state.selectedPlanListRows = payload;
  },
  setSchemeExceptionMasterDropDown(state, payload) {
    state.schemeExceptionMasterDropDown = payload;
  },
  setPartnerTypeFromLists(state, payload) {
    state.partnerTypeFromLists = payload;
  },
  setPartnerCodeLists(state, payload) {
    state.partnerCodeListsSellerExclusion = payload;
  },
  setPartnerTypeToLists(state, payload) {
    state.partnerTypeToLists = payload;
  },
  setDemoDeductionDropDownOptions(state, payload) {
    state.demoDropDownOptionsData = payload;
  },
  setStoreConditionEligibity(state, payload) {
    state.storeConditionEligibityArr = payload;
  },
  setIsAddModifyAddProgram(state, payload) {
    state.isAddModifyAddProgramValue = payload
  },
  setpurposeSelecItem(state, payload) {
    state.purposeSelecItem = payload
  },
  setStoreAddProgramForReportPayout(state, payload) {
    state.storeAddProgramForReportPayoutData = payload
  },

};

export default mutations;
